import hfLogo1 from "../assets/healthfunds/payment-options-1.png";
import hfLogo2 from "../assets/healthfunds/payment-options-2.png";
import hfLogo3 from "../assets/healthfunds/payment-options-3.png";
import hfLogo4 from "../assets/healthfunds/payment-options-4.png";
import hfLogo5 from "../assets/healthfunds/payment-options-5.png";
import hfLogo6 from "../assets/healthfunds/payment-options-6.png";

const hfLogosList = [
    hfLogo1, hfLogo2, hfLogo3, hfLogo4, hfLogo5, hfLogo6
];

export default hfLogosList;
